// Dane strukturalne w HTML z serwera (next/script wstawiał je dopiero w przeglądarce i przy tym samym id
// zostawiał jeden blok na stronie); „<” zamienione, żeby treść nie zamknęła znacznika.
export default function jsonLd (object) {
    return object
        ? <script dangerouslySetInnerHTML={{ __html: JSON.stringify(object).replace(/</g, '\\u003c') }} type="application/ld+json" />
        : null
}
